<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useNavigation } from '../../composables/useNavigation/useNavigation';

const { currentRoute } = useRouter();
const { mainLinks } = useNavigation();
</script>
<template>
  <scale-telekom-nav-list
    variant="main-nav"
    slot="main-nav"
    aria-label="Main navigation links"
  >
    <router-link
      v-for="link of mainLinks"
      :key="link.name"
      :to="{ name: link.name, params: { lang: currentRoute.params['lang'] || 'en' } }"
      custom
      v-slot="{ isActive, href, navigate }"
    >
      <scale-telekom-nav-item
        :active="isActive"
        :aria-label="$t(link.titleKey)"
      >
        <a
          :href="href"
          :title="$t(link.titleKey)"
          :aria-current="isActive"
          @click="navigate"
          >{{ $t(link.titleKey) }}</a
        >
      </scale-telekom-nav-item>
    </router-link>
  </scale-telekom-nav-list>
</template>
